import React from 'react';
import { Radio, FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomRadio = styled(Radio)(({ theme }) => ({
  color: theme.palette.primary.main,
  '&.Mui-checked': {
    color: theme.palette.primary.main,
  },
  '&.Mui-disabled': {
    color: theme.palette.text.disabled,
  },
}));

const CustomFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  '.MuiFormControlLabel-label': {
    fontSize: '13px',
    color: theme.palette.text.primary,
  },
}));

export const RadioButton = ({ label, value, checked, onChange, name, ...props }) => {
  return (
    <CustomFormControlLabel
      value={value}
      control={<CustomRadio checked={checked} onChange={onChange} {...props} />}
      label={label}
      name={name}
    />
  );
};